@if (_report) {
<div class="card">
  <div class="card-body">
    <h5 class="card-title">
      Schedule for Report {{ _report.id }} - {{ _report.reportName }}
    </h5>
    <form
      method="post"
      action="/"
      class="form-horizontal"
      [formGroup]="scheduleForm"
      autocomplete="off"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>ID</mat-label>
                <input
                  id="id"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="id"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <!-- <div class="form-group"
                  [ngClass]="{ 'has-danger': (scheduleF.status.errors && (scheduleF.status.touched ||scheduleF.status.dirty)), 'has-success': !scheduleF.status.errors }">
                  <label class="mat-form-field-required-marker">Status</label>
                  <mat-select id="status" required class="form-control"
                    ngClass=" btn-round simple"
                    formControlName="status">
                    @for (status of mdenumScheduleStatus.values(); track status) {
                      <mat-option
                        [value]="mdenumScheduleStatus[status]">
                        {{ status }}
                      </mat-option>
                    }
                  </mat-select>
                  @for (validation of schedule_validation_messages.status; track validation) {
                    <mat-error>
                      @if (scheduleForm.get('status').hasError(validation.type) && (scheduleForm.get('status').dirty || scheduleForm.get('status').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </div> -->
          </div>
          <div class="col-md-4">
            <!-- <div class="form-group"
                  [ngClass]="{ 'has-danger': (scheduleF.reportFormat.errors && (scheduleF.reportFormat.touched ||scheduleF.reportFormat.dirty)), 'has-success': !scheduleF.reportFormat.errors }"> -->
            <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
            <!--                  <mat-form-field class="example-full-width">-->
            <!-- <label>Report Format</label>
                <mat-select id="reportFormat" required
                  class="form-control"
                  ngClass=" btn-round simple"
                  formControlName="reportFormat">
                  @for (reportFormat of this._report.reportFormatsAllowed; track reportFormat) {
                    <mat-option
                      [value]="reportFormat">
                      {{ reportFormat }}
                    </mat-option>
                  }
                </mat-select>
                @for (validation of schedule_validation_messages.reportFormat; track validation) {
                  <mat-error>
                    @if (scheduleForm.get('reportFormat').hasError(validation.type) && (scheduleForm.get('reportFormat').dirty || scheduleForm.get('reportFormat').touched)) {
                      <mat-error class="error-message"
                        >
                        {{validation.message}}
                      </mat-error>
                    }
                  </mat-error>
                } -->
            <!--                  </mat-form-field>-->
            <!-- </div> -->
          </div>
          <div class="col-sm-4">
            <!-- <div class="form-group"
              [ngClass]="{ 'has-danger': (scheduleF.timePeriod.errors && (scheduleF.timePeriod.touched ||scheduleF.timePeriod.dirty)), 'has-success': !scheduleF.timePeriod.errors }">
              <label class="mat-form-field-required-marker">Period</label>
              <mat-select id="timePeriod" required class="form-control"
                ngClass=" btn-round simple" (selectionChange)="changeTimePeriod($event.value)"
                formControlName="timePeriod">
                @for (period of mdenumScheduleTimePeriod.values(); track period) {
                  <mat-option
                    [value]="mdenumScheduleTimePeriod[period]">
                    {{ period }}
                  </mat-option>
                }
              </mat-select>
              @for (validation of schedule_validation_messages.timePeriod; track validation) {
                <mat-error>
                  @if (scheduleForm.get('timePeriod').hasError(validation.type) && (scheduleForm.get('timePeriod').dirty || scheduleForm.get('timePeriod').touched)) {
                    <mat-error class="error-message"
                      >
                      {{validation.message}}
                    </mat-error>
                  }
                </mat-error>
              }
            </div> -->
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Run Every</mat-label>
                <input
                  id="timePeriodEvery"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="timePeriodEvery"
                />
                <mat-hint
                  class="font-italic"
                  style="font-size: small"
                  [innerText]="timePeriodEveryHint"
                ></mat-hint>
                @for (validation of
                schedule_validation_messages.timePeriodEvery; track validation)
                {
                <mat-error>
                  @if
                  (scheduleForm.get('timePeriodEvery').hasError(validation.type)
                  && (scheduleForm.get('timePeriodEvery').dirty ||
                  scheduleForm.get('timePeriodEvery').touched)) {
                  <mat-error class="error-message">
                    {{ validation.message }}
                  </mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div
              class="form-group"
              [hidden]="scheduleF['timePeriodDay'].disabled"
            >
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Run On Days</mat-label>
                <input
                  id="timePeriodDay"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="timePeriodDay"
                />
                <mat-hint
                  class="font-italic"
                  style="font-size: small"
                  [innerText]="timePeriodDayHint"
                ></mat-hint>
                @for (validation of schedule_validation_messages.timePeriodDay;
                track validation) {
                <mat-error>
                  @if(scheduleForm.get('timePeriodDay').hasError(validation.type)
                  && (scheduleForm.get('timePeriodDay').dirty ||
                  scheduleForm.get('timePeriodDay').touched)) {
                  <mat-error class="error-message">
                    {{ validation.message }}
                  </mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <!-- <div class="form-group"
                  [ngClass]="{ 'has-danger': (scheduleF.dailyFrequency.errors && (scheduleF.dailyFrequency.touched ||scheduleF.dailyFrequency.dirty)), 'has-success': !scheduleF.dailyFrequency.errors }">
                  <label class="mat-form-field-required-marker">Daily Frequency</label>
                  <mat-select id="dailyFrequency" required class="form-control"
                    ngClass=" btn-round simple" (selectionChange)="changeDailyFrequency($event.value)"
                    formControlName="dailyFrequency">
                    @for (freq of mdenumScheduleDailyFrequency.values(); track freq) {
                      <mat-option
                        [value]="mdenumScheduleDailyFrequency[freq]">
                        {{ freq }}
                      </mat-option>
                    }
                  </mat-select>
                  @for (validation of schedule_validation_messages.dailyFrequency; track validation) {
                    <mat-error>
                      @if (scheduleForm.get('dailyFrequency').hasError(validation.type) && (scheduleForm.get('dailyFrequency').dirty || scheduleForm.get('dailyFrequency').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </div> -->
          </div>
          <div class="col-sm-4">
            <!-- <div class="form-group" [hidden]="scheduleF['dailyFrequencyTime'].disabled"
                  [ngClass]="{ 'has-danger': (scheduleF.dailyFrequencyTime.errors && (scheduleF.dailyFrequencyTime.touched ||scheduleF.dailyFrequencyTime.dirty)), 'has-success': !scheduleF.dailyFrequencyTime.errors }">
                  <label class="mat-form-field-required-marker">Daily Frequency Time</label>
                  <mat-select id="dailyFrequencyTime" required class="form-control"
                    ngClass=" btn-round simple" (selectionChange)="changeDailyFrequencyTime($event.value)"
                    formControlName="dailyFrequencyTime">
                    @for (status of mdenumScheduleDailyFrequencyTime.values(); track status) {
                      <mat-option
                        [value]="mdenumScheduleDailyFrequencyTime[status]">
                        {{ status }}
                      </mat-option>
                    }
                  </mat-select>
                  @for (validation of schedule_validation_messages.dailyFrequencyTime; track validation) {
                    <mat-error>
                      @if (scheduleForm.get('dailyFrequencyTime').hasError(validation.type) && (scheduleForm.get('dailyFrequencyTime').dirty || scheduleForm.get('dailyFrequencyTime').touched)) {
                        <mat-error class="error-message"
                          >
                          {{validation.message}}
                        </mat-error>
                      }
                    </mat-error>
                  }
                </div> -->
          </div>
          <div class="col-sm-4">
            <div
              class="form-group"
              [hidden]="scheduleF['dailyIncrement'].disabled"
            >
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Daily Increment</mat-label>
                <input
                  id="dailyIncrement"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="dailyIncrement"
                />
                <mat-hint
                  class="font-italic"
                  style="font-size: small"
                  [innerText]="dailyIncrementHint"
                ></mat-hint>
                @for (validation of schedule_validation_messages.dailyIncrement;
                track validation) {
                <mat-error>
                  @if(scheduleForm.get('dailyIncrement').hasError(validation.type)
                  && (scheduleForm.get('dailyIncrement').dirty ||
                  scheduleForm.get('dailyIncrement').touched)) {
                  <mat-error class="error-message">
                    {{ validation.message }}
                  </mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email On Completion</mat-label>
                <input
                  id="emailOnCompletion"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="emailOnCompletion"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Daily Start Time</mat-label>
                <input
                  id="dailyStartTime"
                  matInput
                  formControlName="dailyStartTime"
                  size="small"
                  type="time"
                />
              </mat-form-field>

              <!--                            <input id="dailyStartTime" matInput type="text" class="form-control"-->
              <!--                                   formControlName="dailyStartTime">-->
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Daily End Time</mat-label>
                <input
                  id="dailyEndTime"
                  matInput
                  formControlName="dailyEndTime"
                  size="small"
                  type="time"
                />
              </mat-form-field>

              <!--                            <input id="dailyEndTime" matInput type="text" class="form-control"-->
              <!--                                   formControlName="dailyEndTime">-->
            </div>
          </div>
          <div class="col-sm-4"></div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Last Finished</mat-label>
                <input
                  id="lastFinished"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="lastFinished"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Last Schedule</mat-label>
                <input
                  id="lastSchedule"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="lastSchedule"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Last Started</mat-label>
                <input
                  id="lastStarted"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="lastStarted"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Last Result</mat-label>
                <input
                  id="lastResult"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="lastResult"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Record Date</mat-label>
                <input
                  id="recordDate"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="recordDate"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Record Time</mat-label>
                <input
                  id="recordTime"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="recordTime"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row pull-right">
          <div class="col-md col-sm">
            <button
              mat-flat-button
              color="accent"
              class="btn btn-success btn-sm"
              style="margin: 5px"
              (click)="submit()"
              [disabled]="_saveBtnstate || scheduleForm.invalid"
            >
              Save Schedule
            </button>
            <button
              mat-flat-button
              color="accent"
              class="btn btn-info btn-sm"
              type="button"
              style="margin: 5px"
              (click)="resetForm()"
            >
              Clear Form
            </button>
            <!--          <button mat-raised-button class="btn btn-primary btn-sm" -->
            <!--                  (click)="showSwal('warning-message-and-confirmation')" -->
            <!--                  [disabled]="cancelBtnstate" *ngIf="auth.isAuthenticated$ && auth.userHasScopes(['cancel:mdb'])">-->
            <!--            Cancel Mandate-->
            <!--          </button>-->
            @if (_schedule) {
            <button
              mat-flat-button
              color="warn"
              class="btn btn-danger btn-sm"
              style="margin: 5px"
              (click)="showSwal('warning-message-and-confirmation')"
            >
              Delete Schedule
            </button>
            }
            <button
              mat-flat-button
              color="warn"
              class="btn btn-warning btn-sm"
              type="button"
              style="margin: 5px"
              (click)="closeForm()"
            >
              Close Schedule
            </button>
          </div>
        </div>
      </div>
    </form>
    <!-- <ngb-accordion
                            #acc="ngbAccordion"
                            activeIds="ngb-panel-0"
                            class="card-collapse inner-cards-plain"
                            > -->
    <!-- <ngb-panel>
                              <ng-template ngbPanelTitle>
                                <a class="collapsed">
                                  Form Information
                                  <i class="now-ui-icons arrows-1_minimal-down"></i>
                                </a>
                              </ng-template>
                              <ng-template ngbPanelContent>
                                <div class="card-body">
                                  <div class="alert-primary">
                                    <table class="table-bordered">
                                      <tr>
                                        <th>Description</th>
                                        <th>Value</th>
                                      </tr>
                                      <tr>
                                        <td>Response</td>
                                        <td>
                                                           <div class="text_bold text-dark">{{ createResponse | json }}</div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Form Values</td>
                                      <td>
                                        <div class="text_bold text-dark">{{ scheduleForm.value | json }}</div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>Form State</td>
                                      <td>
                                        <div class="text_bold text-dark">
                                          Form Touched: {{ scheduleForm.touched | json }}
                                          <br/>
                                          Form Pristine: {{ scheduleForm.pristine | json }}
                                          <br/>
                                          Form Valid: {{ scheduleForm.valid | json }}
                                          <br/>
                                          SaveBtn State: {{_saveBtnstate}}
                                          <br/>
                                          Invalid Controls: {{getAllErrors(scheduleForm)  | json}}
                                          {{scheduleForm.errors | json}}
                                          <br/>
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </ng-template>
                          </ngb-panel> -->
    <!-- </ngb-accordion> -->
  </div>
</div>
}
